import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

export const selectHasFetchedActiveBatches = (state) => get(state, 'hasFetchedActiveBatches');
export const selectMyBatches = (state) => get(state, 'myBatches', emptyObject);
export const selectOtherBatches = (state) => get(state, 'otherBatches', emptyObject);
export const selectIsOpen = (state) => get(state, 'isMenuOpen', true);
export const selectTotalBatchesCount = (state) => get(state, 'totalBatchesCount', 0);
export const selectPageSize = (state) => get(state, 'pageSize', 25);
export const selectNavBatchByFulfillmentPlanSetId = (state, { fulfillmentPlanSetId }) => {
  const batchAssignedToCurrentUser = selectMyBatches(state)[fulfillmentPlanSetId];
  const batchNotAssignedToCurrentUser = selectOtherBatches(state)[fulfillmentPlanSetId];
  if (!batchAssignedToCurrentUser && !batchNotAssignedToCurrentUser) {
    return emptyObject;
  }
  return batchAssignedToCurrentUser || batchNotAssignedToCurrentUser;
};
export const selectIsLoading = (state) => state.isLoading;
